<template>
<div class="chapter">
<div class="inner_page">
<h1 class="title" id="tp"><a id="pageiii"></a>The Manchurian Candidate</h1>
<p class="title1">Richard Condon</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// tp.vue?779a6bc7